export const inviteUrl = (code: string) =>
  `https://learn.circlechess.com/clubs/invite/${code}`;

export const shareInvite = async (code: string) => {
  const message = `Join my club on Caissa! ${inviteUrl(code)} (link valid 24h)`;
  try {
    await navigator.clipboard.writeText(message);
  } catch (err) {
    alert('Failed to copy invite link to clipboard');
  }
};
